export * from '@fhs/routing/src/routes/(drawer)/account/orders';
export { default } from '@fhs/routing/src/routes/(drawer)/account/orders';
